import { CURRENT_TAX_YEAR, TAX_YEARS } from "../config/taxConfig";
import { CapitalTerm, TaxJurisdiction } from "../types";

export const getCurrentTaxYearCGTRate = (profile) => {
  return profile?.taxRates?.find((rate) => rate?.year === CURRENT_TAX_YEAR);
};

export const getTaxYearByValue = (value) => {
  const taxYearObj = TAX_YEARS?.find((year) => year.value === value);
  return taxYearObj ? taxYearObj.taxYear : null;
};

export const getCGTRateForCurrentYear = (profile) => {
  const currentYear = new Date().getFullYear();

  console.log("[getCGTRateForCurrentYear] profile", profile?.taxRates);
  // Add type safety and better null checking
  if (!profile?.taxRates || !Array.isArray(profile.taxRates)) {
    console.log("[getCGTRateForCurrentYear] profile.taxRates is not an array");
    return null;
  }
  const currentYearRate = profile.taxRates.find((rate) => {
    console.log("rate", rate, rate?.year, currentYear);
    return rate?.year == currentYear;
  });

  return currentYearRate?.rate ?? null;
};

export const getValueOfCgtReportByCapitalTermAndKey = (
  cgtReport,
  capitalTerm,
  key
) => {
  if (!key) {
    return null;
  }
  let r = cgtReport?.[key] || null;
  if (r) {
    return r;
  }

  if (!capitalTerm || capitalTerm === CapitalTerm.ALL) {
    if (cgtReport?.details && cgtReport.details.length === 1) {
      return cgtReport.details[0]?.[key] || null;
    }
    // use overall CGT rate if long term rate available
    capitalTerm = CapitalTerm.LONG_TERM;
  }

  const taxReportByTerm = (cgtReport?.details || []).find(
    (item) => item.capital_term_name === capitalTerm
  );

  return taxReportByTerm?.[key] || null;
};
